import { Schema } from 'normalizr';

export const extraSchema = new Schema('extra', { idAttribute: 'id' });
